import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";

import Apis from "../../config/Apis";
import { headers } from "../../utills";
import {
  get_group_assets,
  get_loraWan,
  getAssets,
  getUnlinkModules,
  getSingleAssets,
  getUnlinkAssets,
  reset_group_assets,
  reset_loraWan,
  resetUnlinkModules,
  resetSingleAssets,
  resetUnlinkAssets,
  set_status_of_group_asset,
  setAssetGroupStatus,
  setAssetStatus,
  setDltModuleFromAsset,
  reset_Modules,
  get_Modules,
  reset_license,
  get_license,
  group_assets_details,
  get_vauto_assets,
  getGroupVehiclesByGroupID,
  getVehicleDetail,
  getPendingAssets,
} from "../Actions/AssetsAction";
import { get_schedule } from "../Actions/ScheduleAction";
import Axios from "../../config/Axios";

export const AssetsMiddleware = {
  createAssets: (params) => {
    // console.log("userData", userdata);

    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();

          if (params?.assetImage) formdata.append("image", params?.assetImage);
          if (params?.name) formdata.append("name", params?.name);
          if (params?.make) formdata.append("make", params?.make);
          if (params?.model) formdata.append("model", params?.model);
          if (params?.vinNo) formdata.append("vin_no", params?.vinNo);
          if (params?.licenseNo)
            formdata.append("license_no", params?.licenseNo);
          if (params?.batteryVolt)
            formdata.append("battery_volt", params?.batteryVolt);
          if (params?.trim) formdata.append("trim", params?.trim);
          if (params?.color) formdata.append("color", params?.color);
          if (params?.stock) formdata.append("stock_no", params?.stock);
          if (params?.year) formdata.append("year", params?.year);
          if (params?.deviceId) formdata.append("device_id", params?.deviceId);
          if (params?.deviceName)
            formdata.append("device_name", params?.deviceName);
          if (params?.lot_no) formdata.append("lot_id", params?.lot_no);

          const data = await Axios.post(
            Apis.createAsset,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            dispatch(
              getSingleAssets({ data: data?.data?.data?.single_assets }),
            );
            dispatch(
              getUnlinkAssets({ data: data?.data?.data?.unlinked_assets }),
            );
          }
        } catch (error) {
          // console.log("error", error);

          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  uploadAssets: (assetsdata = []) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          formdata.append("assets", JSON.stringify(assetsdata));
          const data = await Axios.post(
            Apis.uploadAssets,
            formdata,
            headers.config("application/json"),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            dispatch(getSingleAssets(data?.data?.data));
          }
        } catch (error) {
          // console.log("error", error);

          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  exportAssets: (assetsdata = []) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.exportAssets,
            headers.config("application/json"),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
          }
        } catch (error) {
          // console.log("error", error);

          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getSingleAssets: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(resetSingleAssets());
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata?.name) formdata.append("name", userdata?.name);
          const data = await Axios.post(
            userdata?.url ? userdata?.url : Apis.singleAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(getSingleAssets(data?.data?.data));
            resolve(data);
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getSingleAssetsDetails: (id) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          const data = await Axios.get(
            Apis.singleAssetsDetails(id),
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              setAssetStatus({
                device_id: data?.data?.data?.device_id,
                status: data?.data?.data?.status,
              }),
            );
            dispatch(get_schedule(data?.data?.data?.schedules));
            // dispatch(getSingleAssets(data?.data?.data))
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  sentDownlink: ({ device_id, action, status, asset_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("action", action);
          formdata.append("device_id", device_id);
          if (asset_id) formdata.append("asset_id", asset_id);
          if (status) formdata.append("status", status);
          console.log(formdata);
          const data = await Axios.post(
            Apis.downlink,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(hideLoading());
            dispatch(setAssetStatus({ device_id, status }));
          }
        } catch (error) {
          resolve(true);
          // console.log(error);
          // reject(error);
          dispatch(hideLoading());
          dispatch(
            showAlert({
              title: "sentDownlink",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },
  getPendingAssets: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            userdata?.url
              ? userdata.url
              : userdata?.name
                ? `${Apis.pendingAssets}?name=${userdata?.name}`
                : Apis.pendingAssets,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            // dispatch(
            //   showAlert({ type: "Success", message: data?.data?.message }),
            // );
            dispatch(getPendingAssets(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deletePendingAssets: (record) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", record?.id);
          const data = await Axios.post(
            Apis.deletePendingAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            dispatch(getPendingAssets(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getUnlinkAssets: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(resetUnlinkAssets());
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata?.name) formdata.append("name", userdata?.name);
          const data = await Axios.post(
            userdata?.url ? userdata.url : Apis.unlinkAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            // console.log("dataaaaaaaaa", data);

            dispatch(getUnlinkAssets(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getvautoAssets: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata?.name) formdata.append("name", userdata?.name);
          if (userdata?.type) formdata.append("type", userdata?.type);
          const data = await Axios.get(
            Apis.getVautoAssets(userdata?.type, userdata?.name),
            // formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(get_vauto_assets(data?.data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  importVautoAssets: (record) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", record?.id);
          const data = await Axios.post(
            Apis.importVautoAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  /////////////////////////////////////////////////////////Modules///////////////////////////////////////////////////
  createModules: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          // formdata.append("device_name", userdata?.device_name);
          formdata.append("device_id", userdata?.device_id);
          if (userdata?.moduleImage)
            formdata.append("image", userdata?.moduleImage);
          const data = await Axios.post(
            Apis.createModules,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());
            resolve(data);
            dispatch(get_Modules(data?.data?.data));
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            // dispatch(getUnlinkModules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          console.log("errrrrr", error);

          dispatch(
            showAlert({
              title: "createModules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getUnlinkModules: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata) formdata.append("name", userdata);
          const data = await Axios.post(
            Apis.getUnlinkModules,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(resetUnlinkModules());

            resolve(data);

            dispatch(getUnlinkModules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getModules: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata?.name) formdata.append("name", userdata?.name);
          const data = await Axios.post(
            Apis.getModules(userdata?.url),
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());

            resolve(data);
            dispatch(get_Modules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getHistoryDevices: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata?.moduleId)
            formdata.append("module_id", userdata?.moduleId);
          const data = await Axios.post(
            Apis.getHistoryDevices(userdata?.url),
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());

            resolve(data);
            dispatch(get_Modules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getAssignDevices: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata?.name) formdata.append("name", userdata?.name);
          const data = await Axios.post(
            Apis.getAssignDevices(userdata?.url),
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());

            resolve(data);
            dispatch(get_Modules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  assignAsset: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userdata?.assetId);
          formdata.append("device_id", userdata?.deviceId);
          if (userdata?.ro_number)
            formdata.append("ro_number", userdata?.ro_number);

          const data = await Axios.post(
            Apis.assignAsset,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());

            resolve(data);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            dispatch(get_Modules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getModuleDetails: (id) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          const data = await Axios.get(
            Apis.moduleDetails(id),
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            // dispatch(getSingleAssets(data?.data?.data))
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Module",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateDealershipStatus: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userdata?.id);
          formdata.append("dealership_status", userdata?.dealerShipStatus);
          const data = await Axios.post(
            Apis.dealerShipStatus,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());

            console.log(data);
            resolve(data);
            dispatch(get_Modules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateCarStatus: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userdata?.id);
          formdata.append("car_status", userdata?.carStatus);
          const data = await Axios.post(
            Apis.carStatus,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());

            console.log(data);
            resolve(data);
            dispatch(get_Modules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateAssets: (params) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", params?.id);
          if (params?.assetImage) formdata.append("image", params?.assetImage);
          if (params?.name) formdata.append("name", params?.name);
          if (params?.make) formdata.append("make", params?.make);
          if (params?.model) formdata.append("model", params?.model);
          if (params?.vinNo) formdata.append("vin_no", params?.vinNo);
          if (params?.licenseNo)
            formdata.append("license_no", params?.licenseNo);
          if (params?.batteryVolt)
            formdata.append("battery_volt", params?.batteryVolt);
          if (params?.trim) formdata.append("trim", params?.trim);
          if (params?.color) formdata.append("color", params?.color);
          if (params?.stock) formdata.append("stock_no", params?.stock);
          if (params?.year) formdata.append("year", params?.year);
          if (params?.deviceId) formdata.append("device_id", params?.deviceId);
          if (params?.lot_no) formdata.append("lot_id", params?.lot_no);
          if (params?.deviceName)
            formdata.append("device_name", params?.deviceName);

          const data = await Axios.post(
            Apis.updateAssets,
            formdata,
            headers.config(),
          );
          if (data?.status && data.status == 200) {
            // dispatch(resetSingleAssets());

            resolve(data);
            // console.log(
            //   "Updateeeeeeeeeeedataaaaaaaaaaa",
            //   data?.data?.data?.unlinked_assets,
            // );
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(
              getUnlinkAssets({ data: data?.data?.data?.unlinked_assets }),
            );
            dispatch(
              getSingleAssets({ data: data?.data?.data?.single_assets }),
            );
          } else {
            dispatch(
              showAlert({
                title: "update assets",
                message: data?.message ? data?.message : "Something went wrong",
                type: "Error",
                status: data?.status || 400,
              }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update assets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deleteAssets: (id) => {
    // console.log("userdqata", id);

    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", id);
          const data = await Axios.post(
            Apis.deleteAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            // console.log("dataaaaaaaaaaa", data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(
              getSingleAssets({ data: data?.data?.data?.single_assets }),
            );
            dispatch(
              getUnlinkAssets({ data: data?.data?.data?.unlinked_assets }),
            );
            // dispatch(getUnlinkModules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update assets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateAssetLot: (record) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("lot_id", record?.lot_id);
          formdata.append("id", record?.id);
          const data = await Axios.post(
            Apis.updateAssetLot,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            // console.log("dataaaaaaaaaaa", data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(
              getSingleAssets({ data: data?.data?.data?.single_assets }),
            );
            dispatch(
              getUnlinkAssets({ data: data?.data?.data?.unlinked_assets }),
            );
            // dispatch(getUnlinkModules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update assets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deleteModuleFromAsset: (userData) => {
    // console.log("idd", id.id);

    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.deleteModuleFromAsset(userData?.id),
            headers.config(),
          );
          if (data?.status == 200) {
            console.log("dataaaaaaaa", data);
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            // dispatch(setDltModuleFromAsset(data?.data?.data))
            dispatch(
              getSingleAssets({ data: data?.data?.data?.single_assets }),
            );
            dispatch(
              getUnlinkAssets({ data: data?.data?.data?.unlinked_assets }),
            );

            // dispatch(getUnlinkModules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "delete modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  exportDevices: (assetsdata = []) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.exportDevices,
            headers.config("application/json"),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  /////////////////////////////////////////////////////////////////Group Asset//////////////////////////////////////////////////////////////
  creatAssetGroup: (userdata) => {
    console.log("UserData", userdata);

    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          dispatch(reset_group_assets());
          const formdata = new FormData();
          formdata.append("name", userdata?.title);
          // formdata.append("frequency", userdata?.frequency);
          // formdata.append("start_time", userdata?.startTime);
          // formdata.append("end_time", userdata?.endTime);
          // formdata.append("start_date", userdata?.startDate);
          // formdata.append("end_date", userdata?.endDate);
          for (const [i, element] of userdata?.assetArray.entries()) {
            formdata.append(`assets[${i}]`, element?.id);
          }
          const data = await Axios.post(
            Apis.createAssetGroup,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(resetSingleAssets());

            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );

            dispatch(
              get_group_assets({ data: data?.data?.data?.group_assets }),
            );
            dispatch(
              getSingleAssets({ data: data?.data?.data?.single_assets }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "create assets group",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getAssetGroup: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());

          const data = await Axios.post(
            Apis.getAssetGroup,
            {},
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_group_assets());

            resolve(data);
            dispatch(get_group_assets(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "create assets group",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getAssetsGroupDetails: (id) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          const data = await Axios.get(
            Apis.assetsGroupDetails(id),
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              setAssetGroupStatus({
                id: data?.data?.data?.id,
                status: data?.data?.data?.status,
              }),
            );
            dispatch(group_assets_details(data?.data?.data, id));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getAssetsByGroupId: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata?.id) formdata.append("id", userdata?.id);
          const data = await Axios.post(
            Apis.getassestsbygroup_id,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(getGroupVehiclesByGroupID(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getVehicleDetailByID: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.vehicleDetailByID(params?.id),
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getVehicleDetail(data.data.data));
          }
        } catch (error) {
          console.log(error);
          reject(error);
          dispatch(
            showAlert({
              title: "vehicle detail",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateAssetGroup: (userdata) => {
    // console.log("UserData", userdata);

    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("name", userdata?.title);
          formdata.append("id", userdata?.id);
          for (const [i, element] of userdata?.assetArray.entries()) {
            formdata.append(`assets[${i}]`, element?.id);
          }
          const data = await Axios.post(
            Apis.updateAssetGroup,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_group_assets());

            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(
              get_group_assets({ data: data?.data?.data?.group_assets }),
            );
            dispatch(
              getSingleAssets({ data: data?.data?.data?.single_assets }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "create assets group",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deleteAssetGroup: (id) => {
    // console.log("UserData", userdata);

    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());

          const formdata = new FormData();
          formdata.append("id", id);
          const data = await Axios.post(
            Apis.deleteAssetGroup,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_group_assets());
            dispatch(resetSingleAssets());
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(get_group_assets(data?.data?.data?.group_assets));
            dispatch(getSingleAssets(data?.data?.data?.single_assets));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "create assets group",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  sentGroupDownlink: ({ action, status, group_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("action", action);
          formdata.append("group_id", group_id);
          formdata.append("status", status);
          // console.log(formdata);
          const data = await Axios.post(
            Apis.groupDownlink,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_group_assets());

            resolve(true);
            dispatch(hideLoading());

            dispatch(get_group_assets({ data: data?.data?.data }));
            dispatch(
              setAssetGroupStatus({
                id: group_id,
                status: status,
              }),
            );
            dispatch(set_status_of_group_asset({ device_id: "", status }));
          }
        } catch (error) {
          // console.log(error);
          // reject(error);
          dispatch(hideLoading());
          dispatch(
            showAlert({
              title: "sentDownlink",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  sentDownlinkOfGroupAss: ({ device_id, action, status, asset_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("action", action);
          formdata.append("device_id", device_id);
          formdata.append("asset_id", asset_id);
          formdata.append("status", status);
          // console.log(formdata);
          const data = await Axios.post(
            Apis.groupAssetDownlink,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_group_assets());

            resolve(data?.data?.data);
            dispatch(hideLoading());
            dispatch(get_group_assets(data?.data?.data));

            // dispatch(set_status_of_group_asset({ device_id, status }));
          }
        } catch (error) {
          // console.log(error);
          // reject(error);
          dispatch(hideLoading());
          dispatch(
            showAlert({
              title: "sentDownlink",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  ////////////////////////////////////////////////////////////////Access Sharing//////////////////////////////////////////////
  dealerShareAccess: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("email", userdata?.email);
          formdata.append("asset_id", userdata?.assetId);
          formdata.append("module_id", userdata?.moduleId);
          formdata.append("first_name", userdata?.first_name);
          formdata.append("last_name", userdata?.last_name);
          formdata.append("license_key", userdata?.license_key);
          formdata.append("type", userdata?.type);
          formdata.append(
            "license_duration",
            userdata?.license_duration == "3 years"
              ? "3"
              : userdata?.license_duration == "5 years"
                ? "5"
                : userdata?.license_duration == "1 years"
                  ? "1"
                  : userdata?.license_duration == "7 years"
                    ? "7"
                    : "",
          );
          const data = await Axios.post(
            Apis.dealer_shareAccess,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());

            console.log(data);
            resolve(data);
            dispatch(get_Modules(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  dealerRemoveAccess: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("asset_id", userdata?.assetId);
          formdata.append("user_id", userdata?.userId);
          const data = await Axios.post(
            Apis.dealer_removeAccess,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());
            resolve(data);
            dispatch(get_Modules(data?.data?.data));
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getDealerShareAccess: (status) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          formdata.append("status", status);
          // let query = '';
          // if (status) query += `?status=${status}`;
          const data = await Axios.post(
            `${Apis.getSharedAccess}`,
            formdata,
            headers.config("application/json"),
          );
          if (data?.status == 200) {
            resolve(data);
          }
        } catch (error) {
          // console.log("error", error);

          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deleteModule: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userdata?.id);
          const data = await Axios.post(
            Apis.dltModule,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_Modules());
            console.log(data);
            resolve(data);
            dispatch(get_Modules(data?.data?.data));
            //  dispatch(
            //   showAlert({ type: "Success", message: data?.data?.message })
            // );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateBatteryVolt: ({ battery_volt, asset_id }) => {
    return (dispatch) => {
      // dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();

          if (battery_volt) formdata.append("battery_volt", battery_volt);
          if (asset_id) formdata.append("asset_id", asset_id);
          const data = await Axios.post(
            Apis.getBatteryVolt,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            console.log("updateBatteryVolt=>>>>>>>>>", data);

            // dispatch(hideLoading())
            // dispatch(getAssetsDetail(data.data.data))
          }
        } catch (error) {
          // dispatch(hideLoading())
          dispatch(
            showAlert({
              title: "shareAccess",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  /////////////////////////////////////////////////////////////License Management/////////////////////////////////////////////////

  getlicense: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata) formdata.append("name", userdata?.name);
          const data = await Axios.post(
            Apis.getAllLicense,
            formdata,
            headers.config(),
          );

          if (data?.status == 200) {
            dispatch(reset_license());

            resolve(data);
            dispatch(get_license(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "License Management",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  extendLicense: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userdata?.id);
          formdata.append(
            "extended_duration",
            userdata?.licenseDur == "3 years" ? "3" : "5",
          );
          const data = await Axios.post(
            Apis.extendLicense,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(reset_license());

            console.log(data);
            resolve(data);
            dispatch(get_license(data?.data?.data));
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getSoldHistory: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata) formdata.append("name", userdata?.name);
          const data = await Axios.post(
            Apis.salesHistory,
            formdata,
            headers.config(),
          );

          if (data?.status == 200) {
            resolve(data);
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "License Management",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  importUnprotectedAssets: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          const data = await Axios.post(
            Apis.importUnprotectedAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(getUnlinkAssets(data?.data?.data));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "Import Unprotected Assets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  //   sentDownlinkBattery: ({ device_id, action, status, asset_id }) => {
  //       return dispatch => {
  //           return new Promise(async (resolve, reject) => {
  //               try {
  //                   let formdata = new FormData();
  //                   formdata.append('action', action);
  //                   formdata.append('device_id', device_id);
  //                   if (asset_id)
  //                       formdata.append('asset_id', asset_id);
  //                   if (status)
  //                       formdata.append('status', status);

  //                   console.log(formdata)
  //                   const data = await Axios.post(Apis.downlink, formdata, headers.config());
  //                   if (data?.status == 200) {
  //                       resolve(true)
  //                       if (status)
  //                       console.log("sentDownlinkBattery=>>>>>>>>>", data);

  //                           // dispatch(setAssetStatus({ device_id, status }))
  //                   }
  //               } catch (error) {
  //                   console.log(error)
  //                   reject(error);
  //                   dispatch(
  //                       showAlert({
  //                           title: 'sentDownlink',
  //                           message: error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong!',
  //                           type: 'Error',
  //                           status: error?.response?.status,
  //                       }),
  //                   );
  //               }
  //           });
  //       };
  //   },
  //LORAWAN
  // getLORAWAN: (userdata) => {
  //   return (dispatch) => {
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch(reset_loraWan());
  //         dispatch(showLoading());
  //         const formdata = new FormData();
  //         if (userdata) formdata.append("name", userdata);
  //         const data = await Axios.post(
  //           Apis.loraWan,
  //           formdata,
  //           headers.config()
  //         );
  //         if (data?.status == 200) {
  //           resolve(data);

  //           dispatch(get_loraWan(data?.data?.data));
  //         }
  //       } catch (error) {
  //         // reject(error);
  //         dispatch(
  //           showAlert({
  //             title: "lorawan",
  //             message: error?.response?.data?.message
  //               ? error?.response?.data?.message
  //               : error.message,
  //             type: "Error",
  //             status: error?.response?.status,
  //           })
  //         );
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },
};
